import {extendTailwindMerge} from 'tailwind-merge'

export const twMerge = extendTailwindMerge({
	classGroups: {
		'font-size': [{text: [(value) => Number(value)]}],
	},
})
